export const px2unitless = (pixels: number, context = fontSizeDefaultNumber) =>
  `${pixels / context}em`;

export const fontSizeDefaultNumber = 1;
export const lineHeightNumber = 1.5;
export const lineHeight = `${lineHeightNumber}rem`;
export const fontFamily =
  '"Muli", sans-serif;';
export const fontSizeDefault = `${fontSizeDefaultNumber}rem`;
export const lineHeightDefault = px2unitless(lineHeightNumber);
